import { NetworkRequestException } from '../../../exceptions/networkRequestException';
import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

export function errorToTerm(error: unknown): string {
  return (
    defaultErrorToTerm(error) ??
    (error instanceof NetworkRequestException ? error.message : 'unknown_error')
  );
}
